import * as dataStore from './DataStore';
import ArticleLink from '../models/ArticleLink';

export function getArticles(category) {
	const json = dataStore.getJsonData();
	const lowercaseCategory = category.toLowerCase()

	const raw_articles = json.FeatureContent.RelatedContent && json.FeatureContent.RelatedContent.doc_types.find((cat) => {
		return cat.doc_type.toLowerCase() === lowercaseCategory;
	});

	if (raw_articles) {
		return raw_articles.content.map((article) => {return new ArticleLink(article)});
	}
	else{
		return [];
	}
}

export function getArticlesWithType(category) {
	let articles = getArticles(category);
	articles.forEach(article => {article.title = `${category} - ${article.title}`});

	return articles;
}



// WEBPACK FOOTER //
// ./src/data/ArticleSelector.js